export var Basket;
(function (Basket) {
    /**
     * Add to basket
     */
    let Add;
    (function (Add) {
        Add.path = 'basket/add';
    })(Add = Basket.Add || (Basket.Add = {}));
    /**
     * Change add-to-basket request
     */
    let ChangeRequest;
    (function (ChangeRequest) {
        ChangeRequest.path = 'basket/changeRequest';
    })(ChangeRequest = Basket.ChangeRequest || (Basket.ChangeRequest = {}));
    /**
     * Change basket item qty
     */
    let Qty;
    (function (Qty) {
        Qty.path = 'basket/qty';
    })(Qty = Basket.Qty || (Basket.Qty = {}));
    /**
     * Remove from basket
     */
    let Remove;
    (function (Remove) {
        Remove.path = 'basket/remove';
    })(Remove = Basket.Remove || (Basket.Remove = {}));
    /**
     * Flush basket
     */
    let Flush;
    (function (Flush) {
        Flush.path = 'basket/flush';
    })(Flush = Basket.Flush || (Basket.Flush = {}));
})(Basket || (Basket = {}));
